import PageMeta from "@/components/seo/PageMeta";
import SectionHeading from "@/components/ui/SectionHeading";
import ContactForm from "@/components/contact/ContactForm";
import ScriptText from "@/components/ui/ScriptText";
import { contactContent } from "@/data/content";
import { useContent } from "@/hooks/useContent";

export default function ContactPage() {
  const content = useContent("pages/contact", contactContent);

  return (
    <>
      <PageMeta
        title="Contact Us | Chasing Provence Women's Retreats"
        description="Get in touch with Chasing Provence. Inquire about upcoming women's retreats in Provence, Tuscany, and the Cotswolds, or share your vision for a gathering."
      />

      <div className="min-h-screen bg-parchment px-6 pt-32 pb-20 lg:px-12 lg:pt-40 lg:pb-32">
        <div className="mx-auto max-w-5xl">
          <div className="grid gap-16 lg:grid-cols-[1fr_1.2fr] lg:items-start">
            {/* Left column — intro text */}
            <div className="lg:sticky lg:top-40">
              <SectionHeading
                scriptAccent={content.scriptAccent}
                heading={content.heading}
                centered={false}
              />
              <p className="mb-8 max-w-lg font-body leading-relaxed text-soft-charcoal/70">
                {content.body}
              </p>
              <ScriptText className="text-2xl">We'd love to hear from you</ScriptText>
            </div>

            {/* Right column — form */}
            <ContactForm />
          </div>
        </div>
      </div>
    </>
  );
}
